// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"38e209cb","481":"0a5c6236"}[chunkId] + ".chunk.js";
};